import moment from "moment";
import HolidayButton from "../../components/HolidayButton";
import { useHoliday } from "../../contexts/HolidayContext";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import HolidayListItem from "./components/HolidayListItem";

const NUM_YEARS = 5; // current year + 4

const HolidayListPage = () => {
  const { holidays } = useHoliday();

  const currentYear = moment().year();
  const years = Array.from({ length: NUM_YEARS }, (_, i) => currentYear + i);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Heading>Holidays</Heading>
        <div className="flex items-center gap-2">
          <HolidayButton />
        </div>
      </div>

      <Table>
        <TableHead>
          <TableRow>
            <TableHeader className="w-1/3">Holiday</TableHeader>
            {years.map((year) => (
              <TableHeader key={year} className="text-center">
                {year}
              </TableHeader>
            ))}
            <TableHeader className="w-1/12" />
          </TableRow>
        </TableHead>

        <TableBody>
          {holidays.map((holiday) => (
            <HolidayListItem
              key={holiday._id}
              holiday={holiday}
              years={years}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default HolidayListPage;
